import { getCookie, setCookie, getTopDomain } from './cookies';

export const POSSIBLE_UTM_TAGS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "ym_uid",
  "ym_counter",
  "ga_id",
  "ad_id",
  "adset_id",
  "campaign_id",
  "lead_ad",
];

export const ADDITIONAL_COOKIES = [
  "fp",
  "user_id_hash",
  "session_id",
  "yclid",
];

const UTM_COOKIE = 'brg_utm';
const TOP_DOMAIN_DEPTH = 2;

const decodeSbjsValue = (value: string) => {
  try {
    return decodeURIComponent(value.replace(/\+/g, "%20"));
  } catch {
    return value;
  }
};

export const parseSbjsCookie = (cookieName: string) => {
  const cookieValue = getCookie(cookieName);

  if (!cookieValue) {
    return {};
  }

  return cookieValue.split("|").reduce((acc, part) => {
    const [rawKey, ...rawValue] = part.split("=");

    if (!rawKey || rawValue.length === 0) {
      return acc;
    }

    acc[decodeSbjsValue(rawKey)] = decodeSbjsValue(rawValue.join("="));
    return acc;
  }, {} as Record<string, string>);
};

export const parseUtmFromEp = (epValue?: string) => {
  if (!epValue) {
    return {};
  }

  try {
    const epUrl = new URL(epValue, window.location.origin);
    const params = epUrl.searchParams;

    return POSSIBLE_UTM_TAGS.reduce((acc, key) => {
      const value = params.get(key);
      if (value && value !== "(none)") {
        acc[key] = value;
      }
      return acc;
    }, {} as Record<string, string>);
  } catch {
    return {};
  }
};

export const captureUtm = () => {
  const utmFromUrl = parseUtmFromEp(window.location.href);

  if (!Object.keys(utmFromUrl).length) {
    return;
  }

  const utmQuery = new URLSearchParams(utmFromUrl).toString();

  setCookie(UTM_COOKIE, encodeURIComponent(utmQuery), { domain: getTopDomain(TOP_DOMAIN_DEPTH) });
};

export const getUtmMetadata = (): Record<string, string> => {
  const metaData: Record<string, string> = {
    ...parseUtmFromEp(`?${getCookie(UTM_COOKIE) || ''}`),
    ...parseUtmFromEp(parseSbjsCookie("sbjs_current_add").ep),
    ...parseUtmFromEp(window.location.href),
  };

  ADDITIONAL_COOKIES.forEach((cookieName) => {
    const cookieValue = getCookie(cookieName);
    if (cookieValue) {
      metaData[cookieName] = cookieValue;
    }
  });

  return metaData;
};
import { getCookie, setCookie, getTopDomain } from './cookies';

export const POSSIBLE_UTM_TAGS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "ym_uid",
  "ym_counter",
  "ga_id",
  "ad_id",
  "adset_id",
  "campaign_id",
  "lead_ad",
];

export const ADDITIONAL_COOKIES = [
  "fp",
  "user_id_hash",
  "session_id",
  "yclid",
];

const UTM_COOKIE = 'brg_utm';
const TOP_DOMAIN_DEPTH = 2;

const decodeSbjsValue = (value: string) => {
  try {
    return decodeURIComponent(value.replace(/\+/g, "%20"));
  } catch {
    return value;
  }
};

export const parseSbjsCookie = (cookieName: string) => {
  const cookieValue = getCookie(cookieName);

  if (!cookieValue) {
    return {};
  }

  return cookieValue.split("|").reduce((acc, part) => {
    const [rawKey, ...rawValue] = part.split("=");

    if (!rawKey || rawValue.length === 0) {
      return acc;
    }

    acc[decodeSbjsValue(rawKey)] = decodeSbjsValue(rawValue.join("="));
    return acc;
  }, {} as Record<string, string>);
};

export const parseUtmFromEp = (epValue?: string) => {
  if (!epValue) {
    return {};
  }

  try {
    const epUrl = new URL(epValue, window.location.origin);
    const params = epUrl.searchParams;

    return POSSIBLE_UTM_TAGS.reduce((acc, key) => {
      const value = params.get(key);
      if (value && value !== "(none)") {
        acc[key] = value;
      }
      return acc;
    }, {} as Record<string, string>);
  } catch {
    return {};
  }
};

export const captureUtm = () => {
  const utmFromUrl = parseUtmFromEp(window.location.href);

  if (!Object.keys(utmFromUrl).length) {
    return;
  }

  const utmQuery = new URLSearchParams(utmFromUrl).toString();

  setCookie(UTM_COOKIE, encodeURIComponent(utmQuery), { domain: getTopDomain(TOP_DOMAIN_DEPTH) });
};

export const getUtmMetadata = (): Record<string, string> => {
  const metaData: Record<string, string> = {
    ...parseUtmFromEp(`?${getCookie(UTM_COOKIE) || ''}`),
    ...parseUtmFromEp(parseSbjsCookie("sbjs_current_add").ep),
    ...parseUtmFromEp(window.location.href),
  };

  ADDITIONAL_COOKIES.forEach((cookieName) => {
    const cookieValue = getCookie(cookieName);
    if (cookieValue) {
      metaData[cookieName] = cookieValue;
    }
  });

  return metaData;
};
